import React from 'react';

import {HttpIncidents, useLastHttpIncidents} from 'features/http';
import LoaderCentered from 'shared/ui/LoaderCentered/LoaderCentered';
import PlugNoIncidents from 'shared/ui/Plugs/PlugNoIncidents/PlugNoIncidents';

import {LAST_INCIDENTS_LIMIT} from '../../../lib/incidentTabs';

const SiteIncidentsTab: React.FC = () => {
    const {pagination, isLoading, isFetching} = useLastHttpIncidents(LAST_INCIDENTS_LIMIT);

    return (
        <>
            <LoaderCentered active={isFetching}/>
            <HttpIncidents
                pagination={pagination}
                isLoading={isLoading}
                hidePagination
            />
            {!isLoading && pagination?.items.length === 0 && <PlugNoIncidents size="sm"/>}
        </>
    );
};

export default SiteIncidentsTab;
